document.addEventListener('DOMContentLoaded', () => {
  const sampleButtons = document.querySelectorAll('.order-sample-btn');

  sampleButtons.forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      
      const variantId = btn.dataset.variantId;
      const quantity   = parseInt(btn.dataset.quantity) || 1;
      const feedbackEl = btn.closest('.sample-order').querySelector('.sample-feedback');

      btn.disabled = true;
      btn.textContent = 'Adding...';
      if (feedbackEl) feedbackEl.classList.remove('hidden');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        });

        if (!response.ok) throw new Error('Add to cart failed');

        const data = await response.json();

        // ────────────────────────────────────────────────
        // Success – update UI + open / refresh Ella sidebar cart
        // ────────────────────────────────────────────────

        btn.textContent = 'Sample Added!';
        if (feedbackEl) {
          feedbackEl.textContent = 'Added to cart!';
          feedbackEl.classList.add('success');
        }

        // === Ella-specific triggers (try in this order) ===

        // Option 1 – Most commonly working in Ella (quantity change simulation)
        setTimeout(() => {
          const cartQtyInput = document.querySelector('div.has-items input.item-quantity, .cart__qty-input, .ajaxcart__qty, input[name="updates[]"]');
          if (cartQtyInput) {
            cartQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }, 400);   // small delay helps Ella finish processing the add first

        // Option 2 – Alternative event-based trigger (often used in Ella + page builders)
        document.dispatchEvent(new CustomEvent('cart:reload', { bubbles: true }));
        // or try this one instead / in addition:
        // document.dispatchEvent(new CustomEvent('ajax:cart:updated', { bubbles: true }));

        // Option 3 – If your Ella version uses halo object (some versions do)
        if (window.halo && typeof window.halo.addToCartCallback === 'function') {
          window.halo.addToCartCallback();
        }

        // ────────────────────────────────────────────────

        // Optional: auto-open drawer if none of above works
        // (uncomment only if needed – can cause double-open in some cases)
        /*
        setTimeout(() => {
          const drawerToggle = document.querySelector('.header__cart, .cart-icon, [data-drawer="cart"], .quick-cart-toggle');
          if (drawerToggle) drawerToggle.click();
        }, 800);
        */

        setTimeout(() => {
          btn.textContent = 'Order Sample Product';
          btn.disabled = false;
          if (feedbackEl) {
            feedbackEl.textContent = '';
            feedbackEl.classList.add('hidden');
            feedbackEl.classList.remove('success');
          }
        }, 2500);

      } catch (err) {
        console.error(err);
        btn.textContent = 'Error – Try again';
        btn.disabled = false;
        if (feedbackEl) {
          feedbackEl.textContent = 'Could not add sample';
        }
      }
    });
  });
});